module.exports = __webpack_public_path__ + "img/plat_4880.c1e1a93b.jpg";